// The trade ticket's calls, through the Function's TradeTicketService, which
// acts in Salesforce as the signed-in advisor. Every answer comes back as
// { ok, status, body }, never as a thrown error, so a screen can always show
// Salesforce's own reason for a refusal and keep what the advisor entered.
//
// VITE_TRADE_API_BASE points a local dev server at a locally running Function
// (http://localhost:7171/api); hosted builds use the web app's own /api.
const BASE = (import.meta.env.VITE_TRADE_API_BASE || '/api') + '/TradeTicketService';

async function send(method, path, { query, body } = {}) {
  const qs = query ? '?' + new URLSearchParams(query).toString() : '';
  let res;
  try {
    res = await fetch(`${BASE}/${path}${qs}`, {
      method,
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin',
    });
  } catch {
    return { ok: false, status: 0, body: { error: 'The app could not reach the server. Check your connection; nothing was sent.' } };
  }
  let parsed = null;
  try {
    parsed = await res.json();
  } catch {
    parsed = null;
  }
  if (!parsed || typeof parsed !== 'object') {
    parsed = res.ok ? {} : { error: `The server answered ${res.status} without an explanation.` };
  }
  return { ok: res.ok, status: res.status, body: parsed };
}

export const tradeApi = {
  me: () => send('GET', 'me'),
  household: householdId => send('GET', 'household', { query: { householdId } }),
  myRequests: () => send('GET', 'requests'),
  request: id => send('GET', `requests/${encodeURIComponent(id)}`),
  submit: ticket => send('POST', 'requests', { body: ticket }),
  reply: (id, body) => send('POST', `requests/${encodeURIComponent(id)}/reply`, { body }),
  replace: (id, ticket) => send('POST', `requests/${encodeURIComponent(id)}/replace`, { body: ticket }),
  // Investment Management's screen. Salesforce answers 403 to anyone who is not a trader.
  imQueue: () => send('GET', 'im/queue'),
  imRequest: id => send('GET', `im/requests/${encodeURIComponent(id)}`),
  imAct: (id, body) => send('POST', `im/requests/${encodeURIComponent(id)}/act`, { body }),
};
